[
  {
    "dia": "14T",
    "mupi": 1,
    "hora": "15h45min",
    "numero": 13,
    "titulo": "Rânula: Do Diagnóstico à Abordagem Cirúrgica – Caso Clínico",
    "autor": "João Gustavo Lourenço"
  },
  {
    "dia": "14T",
    "mupi": 1,
    "hora": "15h52min",
    "numero": 14,
    "titulo": "White Oral Lesions: a report of three cases with distinct clinical diagnoses",
    "autor": "Mariana Trigo"
  },
  {
    "dia": "14T",
    "mupi": 1,
    "hora": "15h59min",
    "numero": 15,
    "titulo": "Lipoma no pavimento oral, um diagnóstico imprevisto",
    "autor": "Carlos Salgado"
  }
]